import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { useWidgetContext } from '../../context/widget';
import { WidgetType } from '../../../../types/widget-settings';

interface CreateWidgetModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (widgetId: string) => void;
}

const WIDGET_TYPES: { value: WidgetType; label: string }[] = [
  { value: 'STANDARD', label: 'Estándar' },
  { value: 'STICKY', label: 'Sticky' }
];

export const CreateWidgetModal: React.FC<CreateWidgetModalProps> = ({ open, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { createWidget } = useWidgetContext();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      const newWidget = {
        type: values.type,
        title: values.title || undefined,
        handle: values.handle
      };

      const createdWidget = await createWidget(newWidget);

      message.success('Widget creado con éxito');
      form.resetFields();
      onClose();

      if (onSuccess && createdWidget?.widgetId) {
        onSuccess(createdWidget.widgetId);
      }
    } catch (error) {
      console.error('Error al crear widget:', error);
      message.error('Error al crear widget');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title='Crear Nuevo Widget'
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText='Crear'
      cancelText='Cancelar'
      width={500}
    >
      <Form form={form} layout='vertical' autoComplete='off'>
        <Form.Item
          name='type'
          label='Tipo de Widget'
          rules={[{ required: true, message: 'Por favor selecciona un tipo de widget' }]}
        >
          <Select placeholder='Selecciona un tipo de widget' options={WIDGET_TYPES} />
        </Form.Item>

        <Form.Item name='title' label='Título' tooltip='Nombre del widget'>
          <Input placeholder='e.g., Widget de deportes' maxLength={100} />
        </Form.Item>

        <Form.Item
          name='handle'
          label='Cuenta de Instagram'
          rules={[
            { required: false },
            {
              pattern: /^[a-zA-Z0-9_.]+$/,
              message: 'Formato de Instagram inválido'
            },
            { min: 1, max: 30, message: 'El nombre de usuario de Instagram debe tener entre 1 y 30 caracteres' }
          ]}
          tooltip='Puedes asociar una cuenta de Instagram (opcional)'
        >
          <Input placeholder='e.g., nike' maxLength={30} prefix='@' />
        </Form.Item>
      </Form>
    </Modal>
  );
};
